import { createContext, useContext, type ReactNode } from "react";

interface FloatingWidgetChartLayoutContextValue {
  isChatFullscreen: boolean;
  shouldRenderCharts: boolean;
}

const FloatingWidgetChartLayoutContext = createContext<FloatingWidgetChartLayoutContextValue>({
  isChatFullscreen: false,
  shouldRenderCharts: true,
});

export const FloatingWidgetChartLayoutProvider = ({
  isChatFullscreen,
  shouldRenderCharts = true,
  children,
}: {
  isChatFullscreen: boolean;
  shouldRenderCharts?: boolean;
  children: ReactNode;
}) => (
  <FloatingWidgetChartLayoutContext.Provider value={{ isChatFullscreen, shouldRenderCharts }}>
    {children}
  </FloatingWidgetChartLayoutContext.Provider>
);

export const useFloatingWidgetChartLayout = () => useContext(FloatingWidgetChartLayoutContext);
